import { render, staticRenderFns } from "./SaleAIWalletDialog.vue?vue&type=template&id=6b3b810e"
import script from "./SaleAIWalletDialog.vue?vue&type=script&lang=js"
export * from "./SaleAIWalletDialog.vue?vue&type=script&lang=js"
import style0 from "./SaleAIWalletDialog.vue?vue&type=style&index=0&id=6b3b810e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports